import React from 'react'
import beigeCoverImage from "../assets/Beige and White Simple Course Workbook Cover 3.png"

const Mentorship = () => {
    return (
        <section>
            <section className="flex flex-col mx-auto md:flex-row justify-center items-center gap-8 p-6 md:p-12">
                {/* <!-- Card 1 --> */}
                <div
                    className="bg-[#00a3c7] w-[90%] md:w-[45%] lg:w-[35%] h-[450px] relative rounded-lg shadow-lg p-8 flex flex-col justify-between items-center text-white">
                    {/* <!-- Top Icons and Title --> */}
                    <div className="flex items-center justify-center space-x-4">
                        {/* <!-- Icon Left --> */}
                        <div className="text-5xl md:text-6xl lg:text-7xl absolute top-0 left-2">♦</div>
                        {/* <!-- Title --> */}
                        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold tracking-wider">FUN FACT</h2>
                        {/* <!-- Icon Right --> */}
                        <div className="text-5xl md:text-6xl lg:text-7xl absolute top-0 right-2">♠</div>
                    </div>

                    {/* <!-- Fun Fact Text --> */}
                    <p className="text-center mt-6 leading-relaxed text-lg md:text-xl lg:text-2xl">
                        Do you know that the beauty of mentorship is that someone has gone through the phase(s) of life you’re
                        currently trying to navigate and they get to be a guide. Providing you with the answers you need to get
                        it right with minimal mistakes.
                    </p>

                    {/* <!-- Bottom Icons --> */}
                    <div className="flex items-center justify-center space-x-4 mt-8">
                        {/* <!-- Icon Left --> */}
                        <div className="text-5xl md:text-6xl lg:text-7xl absolute bottom-0 left-2">♣</div>
                        {/* <!-- Icon Right --> */}
                        <div className="text-5xl md:text-6xl lg:text-7xl absolute bottom-0 right-2">♥</div>
                    </div>
                </div>

                {/* <!-- Card 2 --> */}
                <div
                    className="bg-[#00a3c7] w-[90%] md:w-[45%] lg:w-[35%] h-[450px] relative rounded-lg shadow-lg p-8 flex flex-col justify-between items-center text-white">
                    {/* <!-- Top Icons and Title --> */}
                    <div className="flex items-center justify-center space-x-4">
                        {/* <!-- Icon Left --> */}
                        <div className="text-5xl md:text-6xl lg:text-7xl absolute top-0 left-2">♦</div>
                        {/* <!-- Title --> */}
                        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold tracking-wider">FUN FACT</h2>
                        {/* <!-- Icon Right --> */}
                        <div className="text-5xl md:text-6xl lg:text-7xl absolute top-0 right-2">♠</div>
                    </div>

                    {/* <!-- Fun Fact Text --> */}
                    <p className="text-center mt-6 leading-relaxed text-lg md:text-xl lg:text-2xl">
                        Do you know that mentorship provides the following in your own journey:
                        <br />
                        <br />
                        Ease
                        <br />
                        Speed
                        <br />
                        Clarity
                    </p>

                    {/* <!-- Bottom Icons --> */}
                    <div className="flex items-center justify-center space-x-4 mt-8">
                        {/* <!-- Icon Left --> */}
                        <div className="text-5xl md:text-6xl lg:text-7xl absolute bottom-0 left-2">♣</div>
                        {/* <!-- Icon Right --> */}
                        <div className="text-5xl md:text-6xl lg:text-7xl absolute bottom-0 right-2">♥</div>
                    </div>
                </div>
            </section>

            {/* <!-- Section Start --> */}
            <section className="mx-auto w-[90%] p-6 my-12 border-4 border-solid border-[#00A3C7]">
                <p className="mt-2 text-lg font-bold">
                    <span className="text-[#00A3C7]">LOVED YOUNGSTERS</span> group mentorship is a mentorship platform designed to meet teenage needs, ranging from
                    <span className="text-[#00A3C7]">SPIRITUAL</span> to <span className="text-[#00A3C7]">EMOTIONAL</span> and
                    <span className="text-[#00A3C7]">ACADEMIC</span> needs.
                </p>

                {/* <!-- What You Get Section --> */}
                <h2 className="mt-6 text-lg font-bold">What you get with <span className="text-[#00A3C7]">LY
                    MENTORSHIP</span></h2>
                <ul className="mt-2 list-disc ml-6 font-bold">
                    <li>Access to LY courses</li>
                    <li>Weekly bible study</li>
                    <li>
                        <span className="text-[#00A3C7]">LY HOUSES</span> - Our accountability group structure with a designated
                        <span className="text-[#00A3C7]">HOUSE PASTOR/MENTOR</span> who you have access to.
                    </li>
                    <li>A community of <span className="text-[#00A3C7]">CHRISTIAN</span> friends who are heading the same direction
                        as you.</li>
                </ul>

                {/* <!-- Signs Section --> */}
                <h2 className="mt-8 text-lg font-bold">Signs you need to become a loved youngster.</h2>
                <ul className="mt-2 list-disc ml-6 font-bold">
                    <li>You don’t know who you are.</li>
                    <li>You don’t know why you’re on the earth.</li>
                    <li>You’re dealing with trauma and pain</li>
                    <li>You don’t have a community of Christian friends</li>
                    <li>You’re struggling to pray and understand this Christian faith</li>
                    <li>You have questions about Jesus and His nature</li>
                    <li>You’re struggling to love people</li>
                    <li>You don’t think you’re worthy, or useful to anyone or anything.</li>
                    <li>You’re struggling with addictions</li>
                </ul>
            </section>

            <section className="py-10">
                <div className="w-[80%] lg:w-[65%] mx-auto py-8 px-6 md:px-12 border border-solid border-[#3b3b3b] space-y-7">
                    <p className="text-xl md:text-2xl font-bold"><span className="text-[#00A3C7]">SIGN UP</span> AND BECOME A <span className="text-[#00A3C7]">LOVED YOUNGSTER</span></p>
                    <p className="text-xl md:text-2xl font-bold">HEY <span className="text-[#00A3C7]">TEEN</span>,</p>
                    <p className="text-xl md:text-2xl font-bold">IN SEARCH OF A COMMUNITY OF BELIEVERS WHO ARE BOLD ABOUT THEIR FAITH AND UNASHAMED OF THEIR WALK WITH GOD?</p>
                    <p className="text-xl md:text-2xl font-bold">WHAT ARE YOU WAITING FOR?</p>

                    {/* <!-- Flex Container with responsiveness --> */}
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="w-full md:w-[50%] text-xl md:text-2xl font-bold text-center md:text-left mb-4 md:mb-0">
                            HIT THE <span className="text-[#00A3C7]">BUTTON</span> AND SIGN UP TO BECOME ONE OF US, WE'RE WAITING
                        </p>
                        <button className="bg-[#00A3C7] text-white font-bold px-12 md:px-16 py-4 md:py-5 rounded-lg hover:bg-blue-600 duration-700">
                            SIGN UP
                        </button>
                    </div>
                </div>
            </section>

            <section className="text-center py-8 bg-[#00A3C7] my-24">
                <h2 className="text-white text-2xl md:text-3xl font-bold">BROWSE OUR TRANSFORMATIVE COURSES</h2>
                <p className="text-white text-xl md:text-2xl font-bold mt-2">THAT LEAD YOU INTO WHOLENESS</p>

                {/* <!-- Cards Container --> */}
                <div className="flex flex-wrap justify-center gap-8 mt-8">
                    {/* <!-- Single Card Start --> */}
                    <div className="bg-white rounded-lg shadow-lg max-w-xs w-full md:w-1/2 lg:w-1/5">
                        <img className="w-full rounded-t-lg" src={beigeCoverImage} alt="Journey to Wholeness Image1" />
                        <div className="p-4">
                            <h3 className="text-gray-600 font-bold text-lg">JOURNEY TO WHOLENESS</h3>
                            <p className="text-gray-500 text-sm mt-1">FOR TEENS</p>
                            <hr className="my-4 border-gray-300" />
                                <p className="text-gray-400 text-xs">BY ANGOLAV</p>
                        </div>
                    </div>
                    {/* <!-- Single Card End --> */}

                    {/* <!-- Duplicate Card Start --> */}
                    <div className="bg-white rounded-lg shadow-lg max-w-xs w-full md:w-1/2 lg:w-1/5">
                        <img className="w-full rounded-t-lg" src={beigeCoverImage} alt="Journey to Wholeness Image2" />
                        <div className="p-4">
                            <h3 className="text-gray-600 font-bold text-lg">JOURNEY TO WHOLENESS</h3>
                            <p className="text-gray-500 text-sm mt-1">FOR TEENS</p>
                            <hr className="my-4 border-gray-300" />
                                <p className="text-gray-400 text-xs">BY ANGOLAV</p>
                        </div>
                    </div>
                    {/* <!-- Duplicate Card End --> */}

                    {/* <!-- Duplicate Card Start --> */}
                    <div className="bg-white rounded-lg shadow-lg max-w-xs w-full md:w-1/2 lg:w-1/5">
                        <img className="w-full rounded-t-lg" src={beigeCoverImage} alt="Journey to Wholeness Image3" />
                        <div className="p-4">
                            <h3 className="text-gray-600 font-bold text-lg">JOURNEY TO WHOLENESS</h3>
                            <p className="text-gray-500 text-sm mt-1">FOR TEENS</p>
                            <hr className="my-4 border-gray-300" />
                                <p className="text-gray-400 text-xs">BY ANGOLAV</p>
                        </div>
                    </div>
                    {/* <!-- Duplicate Card End --> */}

                    {/* <!-- Duplicate Card Start --> */}
                    <div className="bg-white rounded-lg shadow-lg max-w-xs w-full md:w-1/2 lg:w-1/5">
                        <img className="w-full rounded-t-lg" src={beigeCoverImage} alt="Journey to Wholeness Image4" />
                        <div className="p-4">
                            <h3 className="text-gray-600 font-bold text-lg">JOURNEY TO WHOLENESS</h3>
                            <p className="text-gray-500 text-sm mt-1">FOR TEENS</p>
                            <hr className="my-4 border-gray-300" />
                                <p className="text-gray-400 text-xs">BY ANGOLAV</p>
                        </div>
                    </div>
                    {/* <!-- Duplicate Card End --> */}
                </div>
            </section>
        </section>
    )
}

export default Mentorship